import { SagaIterator } from 'redux-saga';
import { call, select, throttle } from 'redux-saga/effects';

import { RootState } from 'js/types';

import { track } from '../mixpanelProvider';

let lastTrackedDateInMemory = '';

const FIFTEEN_SECONDS = 15 * 1000;
const LAST_TRACKED_DATE_STORAGE_KEY = 'VSCLastAccessTrackedDate' as const;

const selectUserId = (state: RootState) => state.auth.currentUser.id;

const buildStorageKey = (userId: string) => `${LAST_TRACKED_DATE_STORAGE_KEY}_${userId}`;

const getLastCheckedDateLocalStorage = (userId: string) => {
  const key = buildStorageKey(userId);
  return localStorage.getItem(key);
};

const setLastCheckedDateLocalStorage = (userId: string, date: string) => {
  const key = buildStorageKey(userId);
  try {
    localStorage.setItem(key, date);
  } catch (error) {
    console.error('Failed to write to localStorage:', error);
  }
};

function* trackProductAccess(): SagaIterator<void> {
  const todayUTC = new Date().toISOString().split('T')[0];

  if (lastTrackedDateInMemory === todayUTC) {
    return;
  }

  const userId = yield select(selectUserId);

  if (!userId) return;

  const lastAccessDateInStorage = getLastCheckedDateLocalStorage(userId);
  if (lastAccessDateInStorage && lastAccessDateInStorage === todayUTC) {
    lastTrackedDateInMemory = todayUTC;
    return;
  }

  lastTrackedDateInMemory = todayUTC;
  setLastCheckedDateLocalStorage(userId, todayUTC);

  yield call(track, 'Daily Product Access');
}

export default function* trackDailyProductAccess() {
  yield throttle(FIFTEEN_SECONDS, '*', trackProductAccess);
}
